import { PerCountry, SiteCountry } from '../../data/models/locale'

export const placeholder: PerCountry<string> = {
  [SiteCountry.nl]: 'Geef een stad op',
  [SiteCountry.be]: 'Geef een stad op',
  [SiteCountry.uk]: 'Exclude a city',
  [SiteCountry.ie]: 'Exclude a city',
  [SiteCountry.dk]: 'Ekskluder en storby',
}

export const searchPromptText: PerCountry<string> = {
  [SiteCountry.nl]: 'Type om te zoeken',
  [SiteCountry.be]: 'Type om te zoeken',
  [SiteCountry.uk]: 'Type to search',
  [SiteCountry.ie]: 'Type to search',
  [SiteCountry.dk]: 'Søg',
}
